export default __webpack_public_path__ + "static/media/img-5.f993e1cf.png";